import styled from "styled-components";

interface IStep {
  color?: string
}

export const Container = styled.div`
  margin: 36px auto 0;
  
  @media (min-width: 1200px) {
    width: 1024px;
    padding-bottom: 138px;
  }

  @media (min-width: 980px) {
    margin: 227px auto 0;
    position: relative;
  }
`

export const StepsLine = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 980px) {
    align-items: center;
    flex-direction: row;
  }
`

export const MobileStepArrow = styled.div`
  position: absolute;
  top: calc(100% - 18px);
  left: 25px;
  
  @media (min-width: 980px) {
    display: none;
  }
`

export const StepInfo = styled.div<IStep>`
  border-radius: 8px;
  padding: 22px;
  background: ${({ color }) => color && color || '#fff' };
  order: 2;
  position: relative;
  left: -10px;
  min-height: 130px;
  margin-right: -10px;
  flex: 1 ;

  @media (min-width: 980px) {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    min-width: 245px;
    margin-right: 0;
  }
`

export const Step = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin: 25px 0 0;

  @media (min-width: 980px) {
    display: block;
    height: 72px;
    flex: 0 0 72px;
    max-width: 72px;
    margin: 0 12px;
  }
  
  &:first-child {
    ${StepInfo} {
      @media (min-width: 980px) {
        left: -20px;
        transform: translateX(0); 
      }
    }
  }

  &:last-child {
    ${StepInfo} {
      @media (min-width: 980px) {
        min-width: 300px;
      }
    }
    
    ${MobileStepArrow} {
      display: none;
    }
  }
`

export const StepTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  color: #2A2637;
  margin-bottom: 14px;
`

export const StepText = styled.div`
  font-size: 14px;
  line-height: 140%;
  color: #2A2637;
`

export const StepIcon = styled.div`
  font-weight: 300;
  font-size: 28px;
  line-height: 140%;
  color: #2A2637;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #2A2637;
  width: 72px;
  height: 72px;
  position: relative;
  flex: 0 0 72px;
  order: 1;
  z-index: 10;
`

export const StepOdd = styled(Step)`
  ${StepInfo} {
    bottom: calc(100% - 10px);
  }
`

export const StepEven = styled(Step)`
  ${StepInfo} {
    top: calc(100% - 10px)
  }
`

export const StepArrow = styled.div`
  flex: 0 0 124px;
  margin: 0 12px;
  display: none;

  @media (min-width: 980px) {
    display: block;
  }
`

export const FinalStep = styled.div`
  margin: 25px 0 0 62px;
  border-radius: 10px;
  border: 1px dashed #797199;
  padding: 22px;

  @media (min-width: 980px) {
    position: absolute;
    right: 0;
    //bottom: 100%;
    bottom: calc(100% - 20px);
    max-width: 206px;
  }
`

export const FinalStepHeader = styled.div`
  display: flex;
  align-items: center;
`

export const CheckIcon = styled.div`
  margin-left: 10px;
  margin-bottom: 14px;
  
  svg path {
    stroke: #01C716;
  }
`
